import { RegulationProposalAction } from 'app/model/CORE';
import { Button, Col, Divider, notification, Row } from 'antd';
import TimeUtils from 'app/common/util/TimeUtils';
import MeasureUtils from 'app/common/util/MeasureUtils';
import { ForwardOutlined } from '@ant-design/icons';
import React, { PureComponent } from 'react';
import { MonitoredMcdmMeasure } from 'app/model/SOL49';
import './McdmMeasureNotification.less';
import AuthorisationUtils from 'app/common/context/AuthorisationUtils';
import { ModalHandler } from 'app/components/panels/ModalHandler';
import { OpenMcdmMeasure, PartialDashboardDataUpdateEvent } from '../../../common/eventbus/Events';
import { EntityType } from '../../../model/client/SOL49';

interface McdmMeasureNotificationProps {
    monitoredMcdmMeasure: MonitoredMcdmMeasure;
}

export class McdmMeasureNotification extends PureComponent<McdmMeasureNotificationProps> {
    private onOpenNotification(mcdmMeasure: MonitoredMcdmMeasure) {
        notification.close(mcdmMeasure.measure.measureId.id);
        if (AuthorisationUtils.isNmUser())
            MeasureUtils.acknowledgeMcdmMeasures([mcdmMeasure]).then(([mcdmMeasure]) => {
                OpenMcdmMeasure.fireEvent([mcdmMeasure]);
                PartialDashboardDataUpdateEvent.fireEvent(EntityType.MEASURE_PROPOSAL);
            });
        else {
            ModalHandler.showRegulationEditor(
                MeasureUtils.getTvLocation(mcdmMeasure.measure).id,
                'tv',
                mcdmMeasure.measure,
            );
        }
    }

    render() {
        const { measure, mcdmMeasureTopic } = this.props.monitoredMcdmMeasure;

        let proposalStatus = 'NEW CREATION'; // Default status for rerouting
        if (MeasureUtils.isRegulationProposal(measure)) {
            switch (measure.action) {
                case RegulationProposalAction.CANCELLATION:
                    proposalStatus = 'NEW CANCELLATION';
                    break;
                case RegulationProposalAction.CREATION:
                    proposalStatus = 'NEW CREATION';
                    break;
                case RegulationProposalAction.UPDATE:
                    proposalStatus = 'NEW UPDATE';
                    break;
            }
        }

        const state = MeasureUtils.toMcdmMeasureStateString(mcdmMeasureTopic);

        return (
            <div className="notification" key={measure.measureId.id}>
                <div className="header">
                    <i>{proposalStatus}</i>
                </div>
                <Row className="content" wrap={false}>
                    <Col span={4}>
                        <div>{measure.measureId.id}</div>
                        <div>{MeasureUtils.getTvLocation(measure).id}</div>
                    </Col>
                    <Col span={1} className="divider-container">
                        <Divider type="vertical" className="divider" />
                    </Col>
                    <Col span={2}>{TimeUtils.formatHHMM(measure.applicability.from.getTime())}</Col>
                    <Col span={1} className="divider-container">
                        <Divider type="vertical" className="divider" />
                    </Col>
                    <Col span={2}>{TimeUtils.formatHHMM(measure.applicability.to.getTime())}</Col>
                    <Col span={1} className="divider-container">
                        <Divider type="vertical" className="divider" />
                    </Col>
                    <Col span={6}>{MeasureUtils.toMeasureReasonString(measure)}</Col>
                    <Col span={1} className="divider-container">
                        <Divider type="vertical" className="divider" />
                    </Col>
                    <Col span={6}>
                        <Button
                            className="status-button"
                            onClick={() => this.onOpenNotification(this.props.monitoredMcdmMeasure)}>
                            {state}
                            <ForwardOutlined />
                        </Button>
                    </Col>
                </Row>
            </div>
        );
    }
}
